// extracted by mini-css-extract-plugin
export default {"root":"BlockArticleHorizontal_root__nWbLH","media":"BlockArticleHorizontal_media__zH1g9","image":"BlockArticleHorizontal_image__1acl0","text":"BlockArticleHorizontal_text__B8dcX"};